wbApp.filter('reservationStartTimeType', ['$translate', function ($translate) {
    return function (input) {
        switch (input) {
            case 1:
                return $translate.instant('TXT_VAL_CAN_START_AT_WHOLE_OR_HALF_HOUR');
            case 2:
                return $translate.instant('TXT_VAL_CAN_START_AT_WHOLE_HOUR_ONLY');
            case 3:
                return $translate.instant('TXT_VAL_CAN_START_AT_HALF_HOUR_ONLY');
            default:
                return '';
        }
    };
}]);